import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { apiCall } from '../API';
import AsyncActionStore from './AsyncActionStore';
import InputStore from './InputStore';
import FlagStore from './FlagStore';

export default class SetupPasswordStore {
    static PropType = PropTypes.shape({
        minPasswordLength: PropTypes.number.isRequired,
        email: PropTypes.string.isRequired,
        password: InputStore.PropType.isRequired,
        passwordConfirmed: InputStore.PropType.isRequired,
        submit: PropTypes.func.isRequired,
        canSubmit: PropTypes.bool.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class SetupPasswordStore */{
            token: null,
            minPasswordLength: 6,
            apiSubmit: apiCall('/console/password/set'),
            apiSubmitState: new AsyncActionStore(),
            password: new InputStore({ value: '', isTouched: true }),
            passwordConfirmed: new InputStore({ value: '', isTouched: true }),
            passwordVisibility: new FlagStore(false),
            confirmPasswordVisibility: new FlagStore(false),

            get canSubmit() {
                return !this.password.isEmpty && !this.passwordConfirmed.isEmpty;
            },
        }, data);

        this.password.setValidator((value) =>
            (value.length >= this.minPasswordLength));
        this.passwordConfirmed.setValidator((value) =>
            (value.length >= this.minPasswordLength) && (value === this.password.value));
    }

    submit = action(() => {
        if (this.apiSubmitState.isLoading) {
            return Promise.reject();
        }

        this.apiSubmitState.setBase();

        this.password.setTouched(false);
        this.passwordConfirmed.setTouched(false);

        if (!this.password.isValid) {
            this.password.focus();
            return Promise.reject();
        }

        if (!this.passwordConfirmed.isValid) {
            this.passwordConfirmed.focus();
            return Promise.reject();
        }

        return this.apiSubmitState.setLoading(this.apiSubmit({
            email: this.email,
            password: this.password.value,
            token: this.token,
        }));
    });
}
